export default __webpack_public_path__ + "static/media/LMNTLwater2-icon.60b49064.png";